/**
 * Contenido del cierre de la página de precios: la frase que resume qué
 * significa cada plan. Los nombres de los planes (START, PRO, ELITE) se toman
 * de los propios planes y no se traducen.
 */
export const planManifesto = {
  ES: {
    headlineBefore: 'No estás comprando simplemente un TPV. Estás construyendo el ',
    headlineHighlight: 'sistema operativo',
    headlineAfter: ' de tu negocio.',
    cards: [
      { number: '01', before: 'te ayuda a ', bold: 'vender', after: '.' },
      { number: '02', before: 'te ayuda a ', bold: 'gestionar', after: '.' },
      { number: '03', before: 'te ayuda a ', bold: 'escalar', after: '.' },
    ],
    footerBefore: 'Y detrás de la tecnología está ',
  },
  CA: {
    headlineBefore: 'No estàs comprant simplement un TPV. Estàs construint el ',
    headlineHighlight: 'sistema operatiu',
    headlineAfter: ' del teu negoci.',
    cards: [
      { number: '01', before: "t'ajuda a ", bold: 'vendre', after: '.' },
      { number: '02', before: "t'ajuda a ", bold: 'gestionar', after: '.' },
      { number: '03', before: "t'ajuda a ", bold: 'escalar', after: '.' },
    ],
    footerBefore: 'I darrere de la tecnologia hi ha ',
  },
  EN: {
    headlineBefore: 'You are not just buying a POS. You are building the ',
    headlineHighlight: 'operating system',
    headlineAfter: ' of your business.',
    cards: [
      { number: '01', before: 'helps you ', bold: 'sell', after: '.' },
      { number: '02', before: 'helps you ', bold: 'manage', after: '.' },
      { number: '03', before: 'helps you ', bold: 'scale', after: '.' },
    ],
    footerBefore: 'And behind the technology is ',
  },
  FR: {
    headlineBefore: "Vous n'achetez pas simplement un TPV. Vous construisez le ",
    headlineHighlight: "système d'exploitation",
    headlineAfter: ' de votre activité.',
    cards: [
      { number: '01', before: 'vous aide à ', bold: 'vendre', after: '.' },
      { number: '02', before: 'vous aide à ', bold: 'gérer', after: '.' },
      { number: '03', before: 'vous aide à ', bold: 'évoluer', after: '.' },
    ],
    footerBefore: 'Et derrière la technologie, il y a ',
  },
};